import envConfig from '../../static/config';
import AccountsStore from '../stores/AccountsStore';
import { isFeatureEnabledForTestEnv } from './TestEnv';

let backNavigationLocation = undefined;

export const setCardManagementBackNavigation = (newBackNavigation) => {
  backNavigationLocation = newBackNavigation;
};
export const getCardManagementBackNavigation = () => backNavigationLocation;
export const isCardManagementEnabled = () =>
  isFeatureEnabledForTestEnv(envConfig.isCardManagementEnabled) &&
  AccountsStore.isManageCardEnabled();
export const isCardManagementEnabledForAccount = (account) =>
  isFeatureEnabledForTestEnv(envConfig.isCardManagementEnabled) &&
  account.actionsAvailable['/users/card/manage'];
